module.exports = "/assets/dist/images/Steam.png?cb01e0fa8d027b80ef28bd92560bdd5a";